// BXYZ:..:eliot@bosmanxyz.xyz:..:.www.bosmanxyz.xyz

(() => {
  const oppet = 'oppen';
  const stangt = 'stangd';
  const msFranToken = (namn, reserv) => {
    const n = parseFloat(getComputedStyle(document.documentElement).getPropertyValue(namn));
    return Number.isFinite(n) ? n : reserv;
  };
  const reducerad = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const intentOppna = () => (reducerad() ? 0 : msFranToken('--rorelse-intent', 320));
  const intentStang = () => (reducerad() ? 0 : msFranToken('--rorelse-intent', 320) + msFranToken('--rorelse-snabb', 160));
  const stangningsTid = () => (reducerad() ? 0 : msFranToken('--rorelse-svep', 280));

  const hamtaPanel = (rot) => rot.querySelector('.toppmeny__panel');

  const visaBlok = (rot, blockId) => {
    rot.querySelectorAll('[data-blokinnehall]').forEach((sektion) => {
      const aktiv = sektion.dataset.blokinnehall === blockId;
      sektion.hidden = !aktiv;
    });
  };

  const stang = (rot) => {
    const panel = hamtaPanel(rot);
    if (!panel) return;
    window.clearTimeout(rot.toppmenyTimer);

    rot.dataset.state = stangt;
    panel.dataset.state = stangt;

    rot.querySelectorAll('[data-action~="toppmeny/oppna"]').forEach((k) => {
      k.dataset.state = stangt;
      k.setAttribute('aria-expanded', 'false');
    });

    rot.toppmenyTimer = window.setTimeout(() => {
      panel.hidden = true;
      rot.querySelectorAll('[data-blokinnehall]').forEach((s) => { s.hidden = true; });
    }, stangningsTid());
  };

  const oppna = (rot, kontroll) => {
    const panel = hamtaPanel(rot);
    if (!panel) return;
    window.clearTimeout(rot.toppmenyTimer);

    setStalHeader();
    const blockId = kontroll.dataset.blockId;
    visaBlok(rot, blockId);

    const justering = ['vanster', 'mitten', 'hoger'].find((j) =>
      kontroll.classList.contains(`toppstapel__cell--${j}`)
    ) || 'vanster';
    panel.dataset.justering = justering;

    panel.hidden = false;
    rot.dataset.state = oppet;
    panel.dataset.state = oppet;

    rot.querySelectorAll('[data-action~="toppmeny/oppna"]').forEach((k) => {
      const erAktiv = k === kontroll;
      k.dataset.state = erAktiv ? oppet : stangt;
      k.setAttribute('aria-expanded', String(erAktiv));
    });
  };

  const arMobil = () => window.matchMedia('(max-width: 900px)').matches;

  const setStalHeader = () => {
    const huvud = document.querySelector('header');
    if (huvud) document.documentElement.style.setProperty('--header-hojd', `${huvud.offsetHeight}px`);
  };
  setStalHeader();
  window.addEventListener('resize', setStalHeader);

  document.querySelectorAll('[data-component="toppmeny"]').forEach((rot) => {
    rot.addEventListener('pointerenter', (handelse) => {
      if (arMobil()) return;
      window.clearTimeout(rot.toppmenyStangTimer);
      const kontroll = handelse.target.closest('[data-action~="toppmeny/oppna"]');
      if (!kontroll || !rot.contains(kontroll)) return;
      window.clearTimeout(rot.toppmenyOppnaTimer);
      const delay = rot.dataset.state === oppet ? 0 : intentOppna();
      rot.toppmenyOppnaTimer = window.setTimeout(() => oppna(rot, kontroll), delay);
    }, true);

    rot.addEventListener('pointerleave', () => {
      if (arMobil()) return;
      window.clearTimeout(rot.toppmenyOppnaTimer);
      rot.toppmenyStangTimer = window.setTimeout(() => stang(rot), intentStang());
    });
  });

  document.addEventListener('keydown', (handelse) => {
    if (handelse.key !== 'Escape') return;
    document.querySelectorAll('[data-component="toppmeny"][data-state="oppen"]').forEach((rot) => {
      const aktiv = rot.querySelector('[data-action~="toppmeny/oppna"][data-state="oppen"]');
      stang(rot);
      aktiv?.focus();
    });
  });
})();
